<script>
  import SearchListItem from './SeachListItem.svelte'
  import { search as freshSearch } from '../DocumentLibrary/fresh-widget'
  import SearchInput from '../SearchInput.svelte'
  import { bg_kb_red_small_png } from '../../image-base64'
  import LazyImageBg from '../LazyImageBg.svelte'
  import { querystring } from 'svelte-spa-router'
  import { onMount } from 'svelte'
  import { getQueryParam } from '../InstallBase/urlQuery'

  let searchText = ''
  let searchResult = []

  onMount(() => {
    const term = decodeURIComponent(getQueryParam($querystring, 'term'))
    if (term && term.length > 0) {
      searchText = term
      doSearch({key: 'Enter'})
    }
  })

  function doSearch (key) {
    if (key.key !== 'Enter') {
      return
    }
    console.log(`search for "${searchText}"`)
    freshSearch(searchText)
      .then(res => {
        if (res.data) {
          searchResult = res.data
        }
      })
      .catch(err => {
        console.log('search error', err)
      })
  }


</script>

<div class="py-16 px-10">

  <div class="mb-4 sticky top-0">
    <LazyImageBg full={"static/img/bg_kb_red.png"} small={bg_kb_red_small_png} grayscale="0%" brightness="1">
      <div class="px-12 py-5 flex flex-wrap justify-center items-center">

        <div class="text-2xl font-light text-white mr-12 my-5">Knowledge Base & Technical Support</div>

        <div class="mr-8 my-5">
          <SearchInput bind:searchText={searchText} on:search={() => doSearch({key: 'Enter'})} />
        </div>

      </div>
    </LazyImageBg>
  </div>

  <div class="bg-white px-10 py-10" style="min-height: 600px">

    <div class="text-gray-800 text-left mb-4">
      <div class="text-xl mb-8 px-3">
        SEARCH RESULTS <!--FOR <strong>{searchText && searchText.length > 0 ? `${searchText}` : ''}</strong>-->
      </div>

      <div class="border-t border-b border-gray-400 py-5 px-3">
        ARTICLES FOUND MATCHING YOUR CRITERIA: {searchResult.length}
      </div>

    </div>

    {#each searchResult as item}
      <div class="text-left bg-gray-100 my-4 bg-white px-5 pt-4 pb-5 leading-loose shadow">
        <SearchListItem {item} />
      </div>
    {/each}

  </div>
</div>
